import React from 'react';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/client';
import NoNotificationBrick from './NoNotificationBrick';
import AutomatedEvaluationApproval from './notification/AutomatedEvaluationApproval';
import DoYouKnowYourAccount from './notification/DoYouKnowYourAccount';

/**
 * Renders the list of notifications on the dashboard
 * @constructor
 */
export default function DashboardNotifications() {
  const {data, loading, error} = useQuery<DashboardNotifications>(query);

  if (loading || error) {
    return (<NoNotificationBrick/>);
  }

  const onlyVisible = (notifications: DashboardNotification[]) => notifications.filter((notification) => notification.visible);

  if (data && onlyVisible(data.notifications).length === 0) {
    return (<NoNotificationBrick/>);
  }

  return (
    <>
      {data && onlyVisible(data.notifications).map((notification) => {
        switch (notification.type) {
          case 'aea-dashboard':
            return <AutomatedEvaluationApproval key={notification.id}/>;
          case 'dyk-your-account':
            return <DoYouKnowYourAccount key={notification.id}/>;
          default:
            return <div key={notification.id}/>;
        }
      })}
    </>
  );
}

interface DashboardNotification {
  id: string;
  type: string;
  visible: boolean;
}

interface DashboardNotifications {
  notifications: DashboardNotification[];
}

const query = gql`
  query DashboardNotifications {
    notifications: dashboardNotifications {
      id
      type
      visible
    }
  }
`;
